import * as React from 'react';

require('../css/loader.css');

interface Props {
  loadingMessage: string;
  style?: React.CSSProperties;

  // Adding a property to add external css class. 
  divClassName?: string;
  spanClassName?: string;
  svgClassName?: string;
  circleClassName?: string;
}

let LoadingDisplay = (props: Props) => {
  // Check if external css properties comes from parent
  let divUserClass = props.divClassName === null ? '' : props.divClassName;
  let spanUserClass = props.spanClassName === null ? '' : props.spanClassName;
  let svgUserClass = props.svgClassName === null ? '' : props.svgClassName;
  let circleUserClass = props.circleClassName === null ? '' : props.circleClassName;

  return (
    <>
      <div className={`loading-display ${divUserClass}`} style={props.style}>
        <svg
          className={`spinner ${svgUserClass}`}
          width="100%"
          height="100%"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className={`path ${circleUserClass}`}
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="30"
          />
        </svg>
      </div>
      <div style={{textAlign: 'center'}}>
        <span className={`loading-message ${spanUserClass}`}>{props.loadingMessage}</span>
      </div>
    </>
  );
};

export default LoadingDisplay;



// WEBPACK FOOTER //
// ./src/Components/LoadingDisplay.tsx